import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

/**
 * Element <variant-live>: odświeża swoją zawartość po zmianie wariantu na stronie produktu
 * (tak samo jak robią to product-price i product-inventory w motywie Horizon).
 */
class VariantLive extends HTMLElement {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    this.style.display = 'block';
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * @param {any} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        const next = detail.html.querySelector(`variant-live[data-block-id="${this.dataset.blockId}"]`);
        if (next) morph(this, next, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[variant-live] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('variant-live')) {
  customElements.define('variant-live', VariantLive);
}